
import * as React from 'react';
import autobind from 'autobind-decorator';
import Icon from '__common/components/Icon';
import { changeAttachment, changeFlashingAttachment } from 'bom/components/utils/partsSelectionFunctions';
import SelectionControlGroup from 'react-md/lib/SelectionControls/SelectionControlGroup';
import { find } from 'lodash';
import { state } from '__common/store';
import SelectionControl from 'react-md/lib/SelectionControls/SelectionControl';
import { Checkbox, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { bomPartsList } from '../../../../../../decls/bom/parts';
import { getLegacyBomControlProps } from 'bom/components/LegacyBomCheckboxIcon';
import { applyQ4MplDiscontinuedParts } from '__common/utils/versionCompare/versionCompare';
export default class Attachments extends React.Component<attachmentsComponentState, {}> {
  @autobind
  changeAttachment(attachment: string) {
    const { attachmentGroup, attachments } = this.props;
    changeAttachment(attachment, attachmentGroup, attachments);
  }

  @autobind
  changeFlashingAttachment(value: string) {
  const { attachmentGroup, attachments } = this.props;
  changeFlashingAttachment(value, attachmentGroup, attachments);
}

  parseAttachments(attachments: bomPartsList) {
    return attachments.map(attachment => ({ label: attachment.name, value: attachment.number || '' }));
  }

  hideAttachments(attachments: { label: string, value: string }[]) {
    const selectedAttachments = state().bom.selectedAttachmentType;
    const projectVersion = state().projectConfiguration.projectVersion;
    let filteredAttachments = attachments;

    if (applyQ4MplDiscontinuedParts(projectVersion)) {
      filteredAttachments = filteredAttachments.filter(attachment => attachment.value !== '004FLCT');
    }

    if (selectedAttachments && selectedAttachments['tile hooks']) {
      const tileHookSpanishCT1 = find(selectedAttachments['tile hooks'], hook => hook.number === '004CT1S');

      if (tileHookSpanishCT1 && !tileHookSpanishCT1.selected) {
        return filteredAttachments.filter(attachment => attachment.value !== '004FLCT');
      }
    }

    return filteredAttachments;
  }

  getSelectedPartNumber(attachments: bomPartsList) {
    const selected = attachments.filter(attachment => attachment.selected);
    return selected.length ? selected[0].number : '';
  }
getSelectedPartNumbers(attachments) {
  const selections = state().bom.extraParameters?.selections;

  if (selections?.flashings?.length) {
    return selections.flashings;
  }

  return [''];
}

  render() {
    const { attachments, attachmentGroup, legacyCheckboxIcons = false } = this.props;
    const parsedAttachments = this.parseAttachments(attachments);
    const readyAttachments = this.hideAttachments(parsedAttachments);
    const getSelectedPartNumber = this.getSelectedPartNumber(attachments);

    return (
      <div className="attachment-types-selector attachment-group-flex" data-group={attachmentGroup}>
        <div className="attachment-group-label">
          {attachmentGroup.toUpperCase()}
        </div>

        {attachmentGroup.toLowerCase() === 'flashings' ? (
          <div className="attachment-group-items">
            {readyAttachments.map((attachment) => (
              <FormControlLabel
                key={attachment.value}
                className="attachment-item"
                control={
                  <Checkbox
                    {...getLegacyBomControlProps(legacyCheckboxIcons)}
                    checked={this.getSelectedPartNumbers(attachments).includes(attachment.value)}
                    onChange={this.changeFlashingAttachment.bind(this, attachment.value)}
                  />
                }
                label={attachment.label}
              />
            ))}
          </div>
        ) : (
          <RadioGroup
            className="attachment-group-items"
            row
            value={getSelectedPartNumber === 'None' ? '' : getSelectedPartNumber}
            onChange={(e) => this.changeAttachment(e.target.value)}
          >
            {readyAttachments.map((attachment) => (
              <FormControlLabel
                key={attachment.value}
                value={attachment.value}
                control={<Radio {...getLegacyBomControlProps(legacyCheckboxIcons)} />}
                label={attachment.label}
                className="attachment-item"
              />
            ))}
          </RadioGroup>
        )}
      </div>
    );
  }
}
